export default "__VITE_ASSET__CJW7BqKg__ 400w, __VITE_ASSET__DfZrhDFF__ 800w, __VITE_ASSET__CPr86GZD__ 1024w";